module.exports = __webpack_public_path__ + "static/img/logo_8@2x.6f813280.png";